import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

export type FailModalProps = {
    show: boolean;
    onFail: () => void;
    onCancel: () => void;
};

export default function FailModal({ show, onFail, onCancel }: FailModalProps) {
    const onSave = () => {
        onFail();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Fail Submission
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {" "}
                <p>Are you sure you want to fail this submission?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onCancel}>Cancel</Button>
                <Button className="btn-danger" onClick={onSave}>
                    Fail
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
